module.exports = __webpack_public_path__ + "img/2_E.8c33abef.webp";